import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useTranslation } from "react-i18next";
import './cookie-modal.css';
import { Button } from '@mui/material';
import CookieIcon from './cookie-icon';
import { useCookieContext } from './cookie-context';

const CookieModal = () => {
  const [t, i18next] = useTranslation("global");
  const preferences = {
    necessary: true,
    analytics: true,
  };

  const {
    isCookieModalVisible,
    setIsCookieModalVisible,
    openPreferencesModal,
    setIsCookieIcon
  } = useCookieContext();

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setIsCookieModalVisible(true);
    } else {
      setIsCookieModalVisible(false);
      setIsCookieIcon(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
    window.dataLayer.push({ event: 'analytics-consent', consent: 'granted' });
    ReactGA.gtag('consent', 'update', {
      'ad_storage': 'granted',
      'analytics_storage': 'granted',
      'personalization_storage': 'granted',
      'functionality_storage': 'granted',
      'security_storage': 'granted'
    });
    setIsCookieModalVisible(false);
    setIsCookieIcon(true);
  };

  const handleEditPreferences = () => {
    openPreferencesModal();
    setIsCookieModalVisible(false);
  };

  return (
    <>
      {isCookieModalVisible ? (
        <div className="cookie-modal">
          <div className="cookie-modal-content">
            <p>
              {t('modals.cookies.description')} <a href="/politicadecookies" target="_blank" rel="noopener noreferrer">{t('modals.cookies.link')}</a>
            </p>

            <div className="cookie-modal-buttons">
              <Button
                onClick={handleAcceptAll}
                variant='contained'
                color='primary'
                style={{
                  backgroundColor: '#7220db',
                  color: '#ffffff'
                }}

              >
                {t('modals.cookies.acceptBtn')}
              </Button>
              <Button
                onClick={handleEditPreferences}
                variant="outlined"
                color="secondary"
                style={{
                  border: '1px solid #7220db',
                  color: '#7220db'
                }}
              >
                {t('modals.cookies.editBtn')}
              </Button>
            </div>
          </div>
        </div>
      ) :
        (
          <>
            <CookieIcon />
          </>
        )
      }

    </>
  );
};

export default CookieModal;
